import { render, staticRenderFns } from "./icon-speedio-logo-bg-grey.vue?vue&type=template&id=66f6e5dd&"
import script from "./icon-speedio-logo-bg-grey.vue?vue&type=script&lang=ts&"
export * from "./icon-speedio-logo-bg-grey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports